import React, { useEffect, useState, useRef } from 'react'
import {
  Col,
  Container,
  Spinner,
  Form,
  Button,
  Alert,
  Table
} from 'react-bootstrap'
import { guardarIngresoCuit, traerDatosIngresoCuit } from '../utils/requests'

import { useForm } from 'react-hook-form'

function continuarButtonText({ cargandoRequest, tshAnio, declaraciones }) {
  if (cargandoRequest) return 'Cargando...'

  if (declaraciones?.map((d) => d.tshAnio).includes(tshAnio))
    return 'Continuar como nueva rectificación de DDJJ'

  return 'Continuar'
}

function TablaDeclaraciones({ declaraciones }) {
  const linkRef = useRef()
  return (
    <>
      <a style={{ display: 'none' }} ref={linkRef} href="/#">
        #
      </a>

      <h5 className="text-muted text-normal text-uppercase text-center">
        Declaraciones Juradas
      </h5>

      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th className="text-center">#</th>
            <th className="text-center">Año</th>
            <th className="text-center">Tipo</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {declaraciones?.map((ddjj, index) => (
            <tr key={index}>
              <td className="text-center">{ddjj.tshID}</td>
              <td className="text-center">{ddjj.tshAnio}</td>
              <td className="text-center">{ddjj.tshTipo}</td>
              <td className="text-center">
                <Button
                  as="a"
                  variant="outline-primary"
                  onClick={() =>
                    fetch(
                      `/ddjj/api/emision-ddjj/declaracion?tshID=${ddjj.tshID}`
                    )
                      .then((res) => res.blob())
                      .then((blob) => {
                        const href = window.URL.createObjectURL(blob)
                        const a = linkRef.current
                        a.download = `Declaración Jurada - ${ddjj.tshID}.pdf`
                        a.href = href
                        a.click()
                        a.href = ''
                      })
                      .catch((err) => console.log(err))
                  }
                >
                  Descargar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

function Ingreso(props) {
  const [cuitLogueado, setCuitLogueado] = useState(false)
  const [errorCuit, setErrorCuit] = useState('')
  const [cuitARepresentar, setCuitARepresentar] = useState(null)
  const [repFinalizo, setRepFinalizo] = useState(false)
  const [mostrarIngresoCuit, setMostrarIngresocuit] = useState(false)
  const [esAdmin, setEsAdmin] = useState(false)
  const [declaraciones, setDeclaraciones] = useState([])
  const [cargando, setCargando] = useState(true)
  const [cargandoRequest, setCargandoRequest] = useState(false)
  const [tshAnio, setTshAnio] = useState(2020)
  const [targets, setTargets] = useState([])

  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  })

  const { register, errors, formState, getValues } = methods

  useEffect(() => {
    setCargando(true)
    traerDatosIngresoCuit(cuitARepresentar ? cuitARepresentar : null)
      .then(({ status, content }) => {
        if (status === 200) {
          setCuitLogueado(content?.usuario?.cuit_logueado)
          if (
            !cuitARepresentar &&
            content?.usuario?.cuit_logueado !== content.usuario?.cuit
          )
            setCuitARepresentar(content.usuario?.cuit)
          setDeclaraciones(content?.declaraciones)
          setEsAdmin(content?.usuario?.esAdmin)

          if (content?.declaraciones?.map((d) => d.tshAnio).includes(2020)) {
            setTshAnio(2020)
            setTargets([2020])
          } else {
            // Cuando se pueda hacer 2020, agregarlo al array de targets
            //setTargets([2019, 2020])
            setTargets([2019, 2020])
          }
        }
      })
      .finally(() => setCargando(false))
  }, [cuitARepresentar])

  const handleContinue = (
    aceptoRectificacion = false,
    nextLocation = '/ddjj/'
  ) => {
    setCargandoRequest(true)

    const cuit = getValues('cuit')
    const uri =
      cuitARepresentar || cuit
        ? '/ddjj/api/ingreso/cuit/representado'
        : '/ddjj/api/ingreso/cuit'

    const datos = JSON.stringify({
      cuitRepresentado:
        cuitARepresentar || cuit ? cuitARepresentar || cuit : cuitLogueado,
      aceptoRectificacion,
      tshAnio
    })

    return guardarIngresoCuit(uri, datos)
      .then(({ status, content }) => {
        if (status === 200) window.location = nextLocation
        else setErrorCuit(content.error)
        if (status === 401) setRepFinalizo(true)
      })
      .finally(() => setCargandoRequest(false))
  }

  if (cargando)
    return (
      <Container className="padding-top-4x padding-bottom-4x">
        <center>
          <Spinner animation="border" variant={'primary'} />
        </center>
      </Container>
    )

  if (!cuitLogueado)
    return (
      <Alert variant="danger" className="my-5 text-center">
        Ocurrió un error al cargar sus datos. Por favor, intente nuevamente más
        tarde.
      </Alert>
    )

  return (
    <div className="padding-top-4x padding-bottom-4x">
      <h3 className="text-muted text-normal text-uppercase">
        Declaración Jurada
      </h3>
      <h6 className="text-muted text-normal text-uppercase">
        Haga su declaración jurada
      </h6>

      {targets.map((year, idx) => (
        <Button
          key={idx}
          onClick={() => setTshAnio(year)}
          variant={tshAnio === year ? 'primary' : 'secondary'}
        >
          {year}
        </Button>
      ))}

      <hr className="margin-bottom-1x" />
      <div className={'mt-5'}>
        <h6 className="text-muted text-normal">
          {!cuitARepresentar ? 'CUIT' : 'CUIT Representante'}: {cuitLogueado}{' '}
          {esAdmin ? ' - Administrador' : ''}
        </h6>
        {cuitARepresentar && (
          <h6 className="text-muted text-normal">
            CUIT Representado: {cuitARepresentar}
          </h6>
        )}

        <div className={'mt-3'}>
          {declaraciones?.length === 0 ? (
            <Button variant={'primary'} onClick={() => handleContinue()}>
              Continuar
            </Button>
          ) : (
            <>
              <TablaDeclaraciones declaraciones={declaraciones} />

              <Button
                variant={'primary'}
                onClick={() =>
                  handleContinue(
                    declaraciones?.map((d) => d.tshAnio).includes(tshAnio)
                  )
                }
                disabled={cargandoRequest}
              >
                {continuarButtonText({
                  cargandoRequest,
                  tshAnio,
                  declaraciones
                })}
              </Button>
            </>
          )}

          <Button
            variant={'warning'}
            disabled={mostrarIngresoCuit}
            onClick={() => {
              setMostrarIngresocuit(true)
              setErrorCuit('')
            }}
          >
            Continuar con otra CUIT
          </Button>

          {errorCuit?.length > 0 && (
            <p style={{ color: '#FF0000' }}>{errorCuit}</p>
          )}

          {mostrarIngresoCuit && (
            <div className={'mt-5'}>
              <h6 className="text-muted text-normal text-uppercase">
                Ingrese la CUIT para realizar la DDJJ
              </h6>
              <Form noValidate>
                <Form.Row>
                  <Col md={6}>
                    <Form.Group controlId="formCuit">
                      <Form.Control
                        ref={register({
                          pattern: /^[\d]{11}$/,
                          required: true
                        })}
                        type="text"
                        maxLength={11}
                        name="cuit"
                        placeholder="Ingrese Cuit a Declarar"
                        isInvalid={!!errors.cuit}
                        isValid={!errors.cuit && getValues('cuit')}
                      />
                      {errors?.cuit && (
                        <Form.Control.Feedback type="invalid">
                          La CUIT consiste de 11 dígitos numéricos
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col md={3}>
                    <Button
                      variant={'outline-primary'}
                      onClick={() => {
                        setMostrarIngresocuit(false)
                        setErrorCuit('')
                      }}
                    >
                      Cancelar
                    </Button>
                  </Col>

                  <Col md={3}>
                    <Col md={3}>
                      <Button
                        variant={'primary'}
                        disabled={!formState.isValid || cargandoRequest}
                        onClick={() => {
                          const cuit = getValues('cuit')
                          setCuitARepresentar(cuit)
                        }}
                      >
                        {cargandoRequest
                          ? 'Cargando...'
                          : !repFinalizo
                          ? 'Continuar'
                          : 'Continuar como Nueva Rectificación de DDJJ '}
                      </Button>
                    </Col>
                  </Col>
                </Form.Row>
              </Form>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Ingreso